const changelog = {
	title: "Changelog",
};
export default changelog;